import React from "react";
import { Container, Grid, Skeleton, Typography } from "@mui/material";

const BackCoursesFeesSkeleton = () => {
  return (
    <Container>
      <Grid
        container
        sx={{
          heigth: "auto",
          width: "auto",
          marginBottom: 1,
          marginTop: 0,
          paddingBottom: 10,
        }}
        rowSpacing={6}
      >
        <Grid item xs={8}>
          <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
            Costos
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Skeleton variant="rectangular" height={40} />
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid item xs={12} marginTop={7}>
            <Skeleton variant="rectangular" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={40} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={40} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={40} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={40} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default BackCoursesFeesSkeleton;
